import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { TUIKit } from "@/TUIKit";
import { TUICallKit } from "@tencentcloud/call-uikit-vue";
import store from '@/store';
import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authData = ref(store.state.user.authData)
onMounted(() => {
  authData.value = store.state.user.authData
  if (!authData.value.tencentSig) {
    authData.value = JSON.parse(localStorage.getItem('authData') || '{}')
  }
})

return (_ctx: any,_cache: any) => {
  return (authData.value.tencentSig)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(TUIKit), {
          SDKAppID: 1600155834,
          userID: authData.value.onlyCode,
          userSig: authData.value.tencentSig
        }, null, 8, ["userID", "userSig"]),
        _createVNode(_unref(TUICallKit), {
          class: "callkit-container",
          allowedMinimized: true,
          allowedFullScreen: false
        })
      ]))
    : _createCommentVNode("", true)
}
}

})